var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationGratitudeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E2FEF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "like",
    d: "M24.9617 34.9111L25.426 34.3221L24.9617 34.9111ZM28 21.5009L27.4596 22.021C27.601 22.1679 27.7961 22.2509 28 22.2509C28.2039 22.2509 28.399 22.1679 28.5404 22.021L28 21.5009ZM31.0383 34.9111L31.5026 35.5001L31.0383 34.9111ZM25.426 34.3221C23.9104 33.1273 22.2531 31.9605 20.9383 30.48C19.6492 29.0285 18.75 27.3347 18.75 25.1373H17.25C17.25 27.8029 18.3605 29.8363 19.8167 31.476C21.2472 33.0868 23.0708 34.3755 24.4974 35.5001L25.426 34.3221ZM18.75 25.1373C18.75 22.9865 19.9654 21.1828 21.6244 20.4244C23.2361 19.6877 25.4017 19.8828 27.4596 22.021L28.5404 20.9808C26.0985 18.4438 23.2641 18.0256 21.0008 19.0602C18.7847 20.0732 17.25 22.4253 17.25 25.1373H18.75ZM24.4974 35.5001C25.0097 35.9039 25.5595 36.3345 26.1168 36.6602C26.6739 36.9857 27.3096 37.2502 28 37.2502V35.7502C27.6904 35.7502 27.3261 35.6295 26.8736 35.3651C26.4213 35.1008 25.9521 34.7368 25.426 34.3221L24.4974 35.5001ZM31.5026 35.5001C32.9292 34.3755 34.7528 33.0868 36.1833 31.476C37.6395 29.8363 38.75 27.8029 38.75 25.1373H37.25C37.25 27.3347 36.3508 29.0285 35.0617 30.48C33.7469 31.9605 32.0896 33.1273 30.574 34.3221L31.5026 35.5001ZM38.75 25.1373C38.75 22.4253 37.2153 20.0732 34.9992 19.0602C32.7359 18.0256 29.9015 18.4438 27.4596 20.9808L28.5404 22.021C30.5983 19.8828 32.7639 19.6877 34.3756 20.4244C36.0346 21.1828 37.25 22.9865 37.25 25.1373H38.75ZM30.574 34.3221C30.0479 34.7368 29.5787 35.1008 29.1264 35.3651C28.6739 35.6295 28.3096 35.7502 28 35.7502V37.2502C28.6904 37.2502 29.3261 36.9857 29.8832 36.6602C30.4405 36.3345 30.9903 35.9039 31.5026 35.5001L30.574 34.3221Z",
    fill: "#2BA865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationGratitudeImage);
export default __webpack_public_path__ + "static/media/ReservationGratitudeImage.85f701e425ad78f1316810db39623b4f.svg";
export { ForwardRef as ReactComponent };